import React, {useState, useEffect} from 'react'
import Flipcard from '../../../components/landingPage/Flipcards/FullBgFlipcard'
import Section from '../Section'
import styled from "styled-components";
import {PatHighPrecision, PatExcellentAesthetics, PatMinimallyInvasive, PatEasierAffordable, PatOralHealth, PatConnectivity, PatComfortEfficiency, PatConsistentPredictable, PatDDDChairside,} from '../../../images/index'
import { Carousel } from 'react-responsive-carousel';
import { isMobile } from 'react-device-detect';

const indicatorHeight = (isMobile? 10 : 4)
const indicatorWidth = (isMobile? 48 : 20)
const indicatorMargin = (isMobile? '0 4px' : '0 2px')

const indicatorStyle= {
  width: indicatorWidth,
  height: indicatorHeight,
  margin: '0 2px', 
};

function PatientBenefits() {

  const [ activeSlide, setActiveSlide ] = useState(0);

  const [autoPlay, setAutoPlay] = useState(true);

  const nextSlide = () => {
    setActiveSlide(activeSlide+1);
  };

  useEffect(() => { 
    let t;
    

    function timerReset() {
       t= setTimeout(() => setActiveSlide(0), 2000)
    } 

    function timerNext() {
       t= setTimeout(nextSlide, 2000)
    }
    
    

    if(autoPlay){
      if(activeSlide===3-1) {
        timerReset()
      } else {
        timerNext()
      }
    } 

    return() => {
      clearTimeout(t)
    }
    
    
  }, [activeSlide, autoPlay, nextSlide]) 

  const slide1 = [
    {
      id: 1,
      image: PatHighPrecision,
      title: "High Precision",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:2,
      image: PatExcellentAesthetics,
      title:"Excellent Aesthetics",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:3,
      image: PatMinimallyInvasive,
      title:"Minimally Invasive",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
  ]
  
  const slide2 = [
    {
      id:4,
      image: PatEasierAffordable,
      title:"Easier & Affordable",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:5,
      image: PatComfortEfficiency,
      title:"Comfort & Efficiency",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:6,
      image: PatOralHealth,
      title:"Oral Health",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
  ]

  const slide3= [
    {
      id:7,
      image: PatConnectivity,
      title:"Connectivity My XiViX Platform",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:8,
      image: PatConsistentPredictable,
      title:"Consistent & Predictable",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    },
    {
      id:9,
      image: PatDDDChairside,
      title:"XiViX Chairside solutions",
      content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum!"
    }
  ]



  return (
    <div>
      <Section title="Patient Benefits" className="mb-10 lg:mb-20 px-0 sm:px-4 2xl:px-20 items-center" id="PatientBenefits">
        <Carousel swipeable={false} dynamicHeight={false} autoPlay={false} showIndicators={false} selectedItem={activeSlide} showStatus={false} showArrows={false} showThumbs={false}>
          <div className="overflow-x-auto sm:overflow-none flex flex-row justify-center sm:flex-wrap lg:mx-20 gap-2 lg:gap-0 2xl:gap-4" onMouseEnter={()=>setAutoPlay(false)} onMouseLeave={()=>setAutoPlay(true)}>
            {slide1.map(slide1 => {
              return (
                <Flipcard flipcard={slide1} key={slide1.id}/>
              )
            })}
          </div>
          <div className="overflow-x-auto sm:overflow-none flex flex-row justify-center sm:flex-wrap lg:mx-20 gap-2 lg:gap-0 2xl:gap-4" onMouseEnter={()=>setAutoPlay(false)} onMouseLeave={()=>setAutoPlay(true)}>
            {slide2.map(slide2 => {
              return (
                <Flipcard flipcard={slide2} key={slide2.id}/>
              )
            })}
          </div>
          <div className="overflow-x-auto sm:overflow-none flex flex-row justify-center sm:flex-wrap lg:mx-20 gap-2 lg:gap-0 2xl:gap-4">
            {slide3.map(slide3 => {
              return (
                <Flipcard flipcard={slide3} key={slide3.id}/>
              )
            })}
          </div>
        </Carousel>
        <ul className="flex mx-auto max-w-3xl md:px-8 md:w-full justify-center mt-10">
          {slide1.map((slide1, index)=> {
            return (
              <li key={slide1.id} className={`${activeSlide === index ? 'opacity-100 bg-primary' : 'opacity-30 bg-gray-500'}`} style={indicatorStyle} role="button" onClick={()=>setActiveSlide(index)}></li>
              )
          })}
        </ul>
      </Section>
    </div>
  )
}

export default PatientBenefits
